import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { UsuarioService } from '../../services/usuario.service';
import { XsAppConfigService } from 'src/app/common/services/xs-app-config.service';
import { CookieService } from 'ngx-cookie-service';

export interface Parametro{
  idUsuario: number;
}

@Component({
  selector: 'app-opcion-usuario-secundario',
  templateUrl: './opcion-usuario-secundario.component.html',
  styleUrls: ['./opcion-usuario-secundario.component.css']
})
export class OpcionUsuarioSecundarioComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public parametro: Parametro,
    public usuarioService: UsuarioService,
    public xsAppConfigService: XsAppConfigService,
    public dialogRef: MatDialogRef<OpcionUsuarioSecundarioComponent>,
    public dialog: MatDialog,
    private cookieService: CookieService
  ) { }

  opcion: boolean = true;
  opcionesplusd: any = [];
  opciones = [
    {eNroOrden:0}, 
    {eNroOrden:1}, 
    {eNroOrden:2}, 
    {eNroOrden:3}, 
    // {eNroOrden:4}, 
    {eNroOrden:5}, 
    {eNroOrden:6}, 
    {eNroOrden:7}, 
    // {eNroOrden:8}
  ]; //solo para localhost

  plugins: any = [];
  idUsuarioPrincipal: string;

  ngOnInit() {
    this.opcion = true;
    this.idUsuarioPrincipal = this.cookieService.get("idUsuario");
    this.inicializar();
  }
  
  inicializar(){
    /*this.usuarioService.listarOpciones(this.parametro).then(res =>{
      this.opcionesplusd = res.data.listaUsuario;
      // if (res.data.opciones != "[]"){
      //   this.opciones = JSON.parse(res.data.opciones);
      // }
      this.construirPlugins();
    });*/
  }

  onClickAceptar(){
    this.dialogRef.close({ data: null, estado: "CANCELAR" });
  }

  classColumna(plugin){
    let clase = {};

    switch(plugin.selected){
      case true:
        clase['seleccionado'] = true;
        break;
      case false:
        clase['noseleccionado'] = true;
        break;
    }
    return clase;
  }

  onClickOpcion(plugin){
    var index = this.plugins.findIndex(res => res.nombre === plugin.nombre);
    var idEstado = "0";
    if (plugin.selected){
      this.plugins[index].selected = false;
      idEstado = "0";
    }else{
      this.plugins[index].selected = true;
      idEstado = "1";
    }
   // this.usuarioService.modificarOpcionEstado({idUsuario: this.parametro.idUsuario, idOpcion: plugin.id, idEstado: idEstado, idUsuarioPrincipal: this.idUsuarioPrincipal}).then(res =>{});
  }

  construirPlugins(){
    for (let i = 0; i < this.opciones.length; i++){
      this.plugins.push(this.pluginsXs(this.opciones[i].eNroOrden));
    }
    for (let y = 0; y < this.opcionesplusd.length; y++){
      for (let x = 0; x < this.opciones.length; x++){
        if (this.opcionesplusd[y].idOpcion == this.opciones[x].eNroOrden){
          this.plugins[x].selected = true;
          break;
        }
      }
    }
  }

  pluginsXs(opcion){
    switch(opcion){
      case 0:
        return{
          id: 0,
          nombre: "Casillas Electrónicas",
          titulo: "Casillas Electrónicas",
          imagen: "assets/images/casillas_electronicas.png",
          selected: false,
          orden: 1
        }; break;
      case 1:
        return{
          id: 1,
          nombre: "Mesa de Partes Virtual",
          titulo: "Mesa de Partes Virtual",
          imagen: "assets/images/mesa_partes.png",
          selected: false,
          orden: 2
        }; break;
      case 2:
        return{
          id: 2,
          nombre: "Expediente Virtual",
          titulo: "Expediente Virtual",
          imagen: "assets/images/expediente_virtual.png",
          selected: false,
          orden: 3
        }; break;
      case 3:
        return{
          id: 3,
          nombre: "Reporte de Emergencia Ambiental",
          titulo: "Reporte de Emergencia Ambiental",
          imagen: "assets/images/reporte_emergencias.png",
          selected: false,
          orden: 4
        }; break;
      case 4:
        return{
          id: 4,
          nombre: "Presentación de Obligaciones",
          titulo: "Presentación de Obligaciones",
          imagen: "assets/images/documents_64.png",
          selected: false,
          orden: 5
        }; break;
      case 5:
        return{
          id: 5,
          nombre: "Aporte por Regulación",
          titulo: "Aporte por Regulación",
          imagen: "assets/images/apr.png",
          selected: false,
          orden: 6
        }; break;
      case 6:
        return{
          id: 6,
          nombre: "Solicitud de Acceso a la Información",
          titulo: "Solicitud de Acceso a la Información",
          imagen: "assets/images/acceso_informacion.png",
          selected: false,
          orden: 7
        }; break;
      case 7:
        return{
          id: 7,
          nombre: "Quejas / Reclamos",
          titulo: "Quejas / Reclamos",
          imagen: "assets/images/quejas_reclamos.png",
          selected: false,
          orden: 8
        }; break;
      case 8:
        return{
          id: 8,
          nombre: "Otros",
          titulo: "Otros",
          imagen: "assets/images/other_64.png",
          selected: false,
          orden: 9
        }; break;
    }
  }
}
